import React from 'react'

import ContentPage from './ContentPage.jsx'

import es from '../locales/termsOfUse_es.json'
import en from '../locales/termsOfUse_en.json'

function TermsOfUse() {
    return <ContentPage es={es} en={en} />
}

export default TermsOfUse
